// Tiggy, la mascotte de l'app, sur le site public. Utilisé avec parcimonie
// (FAQ, appel final, connexion, pages de confirmation) : voir la spec § 2.
import React from "react";
import clinOeil from "../images/tiggy/tiggy_clin_oeil.png";
import reflexion from "../images/tiggy/tiggy_reflexion.png";
import victoire from "../images/tiggy/tiggy_victoire.png";
import croissance from "../images/tiggy/tiggy_croissance.png";
import pouceLeve from "../images/tiggy/tiggy_pouce_leve.png";
import ordinateur from "../images/tiggy/tiggy_ordinateur.png";

// ratio = largeur / hauteur de l'image.
const POSES = {
	clin_oeil: { src: clinOeil, ratio: 410 / 600 },
	reflexion: { src: reflexion, ratio: 415 / 600 },
	victoire: { src: victoire, ratio: 524 / 600 },
	croissance: { src: croissance, ratio: 539 / 600 },
	pouce_leve: { src: pouceLeve, ratio: 492 / 600 },
	ordinateur: { src: ordinateur, ratio: 600 / 583 },
};

// taille = hauteur en pixels. Décoratif par défaut (alt vide).
export default function Tiggy({ pose = "clin_oeil", taille = 140, className = "", alt = "" }) {
	const def = POSES[pose] || POSES.clin_oeil;
	return (
		<img
			className={`gs-tiggy ${className}`.trim()}
			src={def.src}
			width={Math.round(taille * def.ratio)}
			height={taille}
			alt={alt}
			loading="lazy"
			draggable="false"
		/>
	);
}
